module.exports = __webpack_public_path__ + "static/icon_card-24h-001251abf34e8e37e91e53c9e5f24fed.png";